export const photos = [
    {
        id: "1",
        src: "./img/gallery/1.jpg",
        alt: "gallery",
    },
    {
        id: "2",
        src: "./img/gallery/2.jpg",
        alt: "gallery",
    },
    {
        id: "3",
        src: "./img/gallery/3.jpg",
        alt: "gallery",
    },
    {
        id: "4",
        src: "./img/gallery/4.jpg",
        alt: "gallery",
    },
    {
        id: "5",
        src: "./img/gallery/5.jpg",
        alt: "gallery",
    },
    {
        id: "6",
        src: "./img/gallery/6.jpg",
        alt: "gallery",
    },

]